import { Injectable } from '@angular/core';
import { CloudIdStorageService } from '../../cloud/cloud-id-storage.service';

@Injectable({
  providedIn: 'root'
})
export class InstanceIdHeaderFactoryService {

  constructor(private cloudStorageService: CloudIdStorageService) { }

  createHeader() {
    const instanceId = this.loadCloudId();
    return {InstanceId: instanceId};
  }

  loadCloudId() {
    return this.cloudStorageService.loadCloudId();
  }
}
